function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(0.707107,0.707107,-0.707107,0.707107,16,-6.62741)"
}, React.createElement("path", {
  d: "M14.5,14.5L8,14.5C7.172,14.5 6.5,15.172 6.5,16C6.5,16.828 7.172,17.5 8,17.5L14.5,17.5L14.5,24C14.5,24.828 15.172,25.5 16,25.5C16.828,25.5 17.5,24.828 17.5,24L17.5,17.5L24,17.5C24.828,17.5 25.5,16.828 25.5,16C25.5,15.172 24.828,14.5 24,14.5L17.5,14.5L17.5,8C17.5,7.172 16.828,6.5 16,6.5C15.172,6.5 14.5,7.172 14.5,8L14.5,14.5Z"
}));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.07692,0,0,1.07692,-1.23077,-2.30769)"
}, React.createElement("path", {
  d: "M16,2.607C8.056,2.607 1.607,9.056 1.607,17C1.607,24.944 8.056,31.393 16,31.393C23.944,31.393 30.393,24.944 30.393,17C30.393,9.056 23.944,2.607 16,2.607ZM16,5.393C22.406,5.393 27.607,10.594 27.607,17C27.607,23.406 22.406,28.607 16,28.607C9.594,28.607 4.393,23.406 4.393,17C4.393,10.594 9.594,5.393 16,5.393Z"
}));
var SvgCancel = function SvgCancel(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef
  }, props), _ref2, _ref3);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCancel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cancel.0e18b405.svg";
export { ForwardRef as ReactComponent };